'use client';

import { GsImage, cn } from '@/components/help-center/latest-power-shared';
import type { PriceActivityCategorySummary } from '@/lib/price-activity-types';

type PriceActivityHeaderProps = {
  categoryId: string;
  categoryLabel: string;
  sampleIcon: string;
  summary: PriceActivityCategorySummary;
};

export function PriceActivityHeader({
  categoryLabel,
  sampleIcon,
  summary,
}: PriceActivityHeaderProps) {
  return (
    <div className="flex min-w-0 items-start gap-3.5 pr-10">
      <span
        className={cn(
          'inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl',
          'border border-solid border-sky-400/30',
          'bg-gradient-to-br from-sky-500/20 via-[#0a1450]/80 to-[#060c38]',
          'shadow-[0_0_20px_rgba(56,189,248,0.15)]'
        )}
      >
        <GsImage
          code={sampleIcon}
          className="flex h-8 w-8 items-center justify-center"
          imgClassName="max-h-8 max-w-8 object-contain"
          sizePx={32}
        />
      </span>

      <div className="min-w-0 flex-1 space-y-1 pt-0.5">
        <p className="font-poppins text-[10px] font-semibold uppercase tracking-[0.14em] text-sky-300/80">
          Atividade de Preços
        </p>
        <h2 className="font-poppins text-lg font-bold tracking-tight text-sky-50 sm:text-xl">
          {categoryLabel}
        </h2>
        <p className="font-inter text-sm leading-relaxed text-sky-100/65">
          Últimas alterações nos valores dos powers desta categoria.
        </p>

        {summary.total > 0 ? (
          <div className="flex flex-wrap items-center gap-2 pt-1.5">
            <span className="inline-flex items-center gap-1 rounded-full border border-emerald-400/25 bg-emerald-500/10 px-2 py-0.5 font-poppins text-[10px] font-semibold text-emerald-200">
              ↑ {summary.upCount}
            </span>
            <span className="inline-flex items-center gap-1 rounded-full border border-rose-400/25 bg-rose-500/10 px-2 py-0.5 font-poppins text-[10px] font-semibold text-rose-200">
              ↓ {summary.downCount}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
